import React from "react";
import "./SectionBlock.css";

const SectionBlock = ({ title, description, buttonText, image }) => {
  return (
    <section className="section-block">
      <div className="section-text">
        <h2>{title}</h2>
        <p>{description}</p>
        <button className="section-btn">{buttonText}</button>
      </div>

      <div className="section-image">
        <img src={image} alt="section visual" />
      </div>
    </section>
  );
};

export default SectionBlock;
